import { EVENT_BBOX_DURATION, EventNameColorMap } from '../constants/event.constants';

// Events must be sorted by eventTs, as they are for the history player.
export function getActiveBBoxEvents(events, timestamp) {
  const startIndex = findEventLowerBound(events, timestamp - EVENT_BBOX_DURATION);
  const activeEvents = [];

  for (let index = startIndex; index < events.length; index += 1) {
    const event = events[index];

    if (event.eventTs > timestamp) {
      break;
    }

    if (event.eventRegion && timestamp < event.eventTs + EVENT_BBOX_DURATION) {
      activeEvents.push(event);
    }
  }

  return activeEvents;
}

export function getEventColor(eventName) {
  return EventNameColorMap[eventName] || '#4b9de1';
}

export function getVideoContentRect(video) {
  const videoRect = video.getBoundingClientRect();
  const videoWidth = video.videoWidth;
  const videoHeight = video.videoHeight;
  
  if (!videoWidth || !videoHeight) {
    return videoRect;
  }
  
  const videoAspectRatio = videoWidth / videoHeight;
  const containerAspectRatio = videoRect.width / videoRect.height;
  
  let width;
  let height;
  let left;
  let top;
  
  if (videoAspectRatio > containerAspectRatio) {
    width = videoRect.width;
    height = width / videoAspectRatio;
    left = videoRect.left;
    top = videoRect.top + (videoRect.height - height) / 2;
  } else {
    height = videoRect.height;
    width = height * videoAspectRatio;
    left = videoRect.left + (videoRect.width - width) / 2;
    top = videoRect.top;
  }
  
  return {
    left,
    top,
    width,
    height,
  };
}

export function findEventLowerBound(events, timestamp) {
  let left = 0;
  let right = events.length;
  
  while (left < right) {
    const middle = Math.floor((left + right) / 2);
    
    if (events[middle].eventTs < timestamp) {
      left = middle + 1;
    } else {
      right = middle;
    }
  }
  
  return left;
}
